<template>
  <div class="view-tools-leadlist">
    <h5 class="text-semibold mb-5">Lead List</h5>
    <div class="product-select">
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          v-model="product_id"
          class="my-5"
          id="product-select"
          label="Selecionar um produto"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
    </div>

    <div v-if="product_id !== null">
      <snow-data-table-header
        @add="modal = true"
        :search="false"
        :datePicker="false"
        :filters="false"
        class="mb-3"
      />

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <div
        v-else-if="!events.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block mb-9 mx-auto"
              src="@/assets/images/no-content.svg"
            />
            <h5>Você ainda não cadastrou nenhuma segmentação</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>

      <snow-data-table v-else :data="events" :columns="leadColumns" />

      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>

      <lead-list-modal
        v-model="modal"
        :product_id="product_id"
        :eventToEdit="eventToEdit"
        @refresh="refresh"
      />
    </div>
  </div>
</template>

<script>
import LeadListModal from "@/components/tools/modals/LeadList/Index.vue";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  components: {
    LeadListModal
  },
  data() {
    return {
      modal: false,
      loading: false,
      product_id: null,
      eventToEdit: null,
      page: 1,
      columns: ["Segmentação", "Evento", "Comando", "Provedor", "Status", ""],
      params: {
        offset: 0,
        product_id: null
      },
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Lead List" }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("integration/getTypeEvents");
    this.$store.dispatch("integration/getTypeCommands");
    this.$store.dispatch("integration/getProviders", { limit: 500 });
  },
  watch: {
    product_id(v) {
      if (v) {
        this.dispatch();
      }
    },
    modal(v) {
      if (!v && this.eventToEdit) this.eventToEdit = null;
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", [
      "providers",
      "events",
      "pagination",
      "typeCommands",
      "typeEvents",
      "mapProviderName"
    ]),
    STATUS_MAP() {
      return {
        active: "Ativo",
        draft: "Rascunho",
        inactive: "Inativo"
      };
    },
    leadColumns() {
      return [
        {
          name: "Segmentação",
          field: "name"
        },
        {
          name: "Evento",
          field: "event",
          transform: this.formatEventName
        },
        {
          name: "Comando",
          field: "command",
          transform: this.formatCommand
        },
        {
          name: "Provedor",
          field: "integration",
          transform: this.formatProvider
        },
        {
          name: "Status",
          field: "status",
          transform: v => this.STATUS_MAP[v],
          color: v =>
            ({
              active: "green",
              inactive: "negative",
              draft: "alert"
            }[v]),
          type: "tag"
        },
        {
          name: "",
          type: "menu",
          options: item => this.getActions(item)
        }
      ];
    }
  },
  methods: {
    getActions(item) {
      return [
        {
          label: "Editar",
          click: () => this.edit(item)
        },
        {
          label:
            item.status === "draft" || item.status === "inactive"
              ? "Ativar"
              : "Desativar",
          click: () => this.changeStatus(item)
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            icon: "ph ph-trash",
            text:
              "Tem certeza que deseja excluir segmentação? Leads não serão mais enviados para a mesma.",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Não, cancelar",
            action: () => this.submitDelete(item)
          }
        }
      ];
    },
    formatProvider(v) {
      return get(
        this.mapProviderName,
        get(
          this.providers.find(p => p.id === v),
          "name"
        ),
        "-"
      );
    },
    formatCommand(v) {
      return get(
        this.typeCommands.find(p => p.id === v),
        "name",
        "-"
      );
    },
    formatEventName(v) {
      return get(
        this.typeEvents.find(p => p.id === v),
        "name",
        "-"
      );
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.dispatch();
    },
    dispatch() {
      this.params.product_id = this.product_id;
      this.loading = true;
      this.$store
        .dispatch("integration/getLeadLists", this.params)
        .then()
        .catch(error => {
          this.$message.error("Não foi possível carregar os eventos");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteEvents", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Evento deletado!");
        })
        .catch(error => {
          this.$message.error("Não foi possível deletar o evento");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      const status =
        item.status === "draft" || item.status === "inactive"
          ? "active"
          : "inactive";
      this.$store
        .dispatch("integration/putEvents", {
          id: item.id,
          status
        })
        .then(() => {
          this.$message.success(
            `O evento foi ${status === "active" ? "ativado" : "desativado"}`
          );
          this.refresh();
        })
        .catch(error => {
          this.$message.error("Erro ao salvar segmentação");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(v) {
      this.eventToEdit = v;
      this.modal = true;
    },
    refresh() {
      this.dispatch();
    }
  }
};
</script>
<style lang="scss" scoped>
.view-tools-leadlist {
  .product-select {
    max-width: 384px;
  }
}
</style>
